const pending = 'pending';
const declined = 'declined';
const accepted = 'accepted';

export const InviteStatusMap = {
  pending,
  declined,
  accepted,
} as const;
